import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { FeedbackService } from 'src/app/_provider/feedback.service';
import { SaveService } from 'src/app/_provider/save.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { TaskTemplateBase, TaskTemplateItem } from '../task-template-overview/task-template-overview.page';

@Component({
  selector: 'app-task-template-edit',
  templateUrl: './task-template-edit.page.html',
  styleUrls: ['./task-template-edit.page.scss', "../../setting-main.scss"],
})
export class TaskTemplateEditPage implements OnInit {

  public isNew: boolean = false
  public template: TaskTemplateBase

  public tasks: TaskTemplateItem[] = []
  public templates: TaskTemplateBase[]

  public newTaskDescription: string = ""

  constructor(
    private modalCtrl: ModalController,
    private ticketSrv: TicketEmployee.TicketService,
    private saveSrv: SaveService.Settings,
    private feedback: FeedbackService
  ) { }

  async ngOnInit() {
    if(this.isNew) return

    const result: HttpFunctionResult<TaskTemplateItem[]> = await this.ticketSrv.getTasksByTemplate(this.template.id)
    if(!result.success) return await this.back()

    this.tasks = result.data
    this.sortTasks()

    // this.http.GET(`ticket/editinfo/tasktemplates/${this.template.id}`).subscribe((response: HttpResponse<any>)=>{
    //   this.tasks = response.body.data
    //   this.sortTasks()
    // }, async (err: HttpErrorResponse)=>{
    //   this.back()
    //   await this.http.handleError(err)
    // })
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  private sortTasks(){
    this.tasks.sort((a, b) => a.sort > b.sort ? 1 : a.sort === b.sort ? 0 : -1);
  }

  public async addTask(){
    if(!this.newTaskDescription) return
    this.tasks.push({
      description: this.newTaskDescription,
      templateId: this.template.id,
      sort: this.tasks.length + 1
    })
    this.newTaskDescription = ""
    this.sortTasks()
  }

  public deleteTask(task: TaskTemplateItem){
    this.tasks.splice(this.tasks.indexOf(task), 1)
    this.tasks.forEach((t, index) => t.sort = index + 1)
    this.sortTasks()
  }

  public taskUp(item: TaskTemplateItem){
    if(item.sort == 1) return
    item.sort--
    this.tasks[this.tasks.indexOf(item) - 1].sort++
    this.sortTasks()
  }

  public taskDown(item: TaskTemplateItem){
    if(item.sort == this.tasks.length) return
    item.sort++
    this.tasks[this.tasks.indexOf(item) + 1].sort--
    this.sortTasks()
  }


  public async deleteTemplate(){
    if((!await this.feedback.confirm(`Sind Sie sicher, dass die Vorlage "${this.template.description}" gelöscht werden soll?`, "Löschen", "Abbrechen"))) return
    await this.feedback.updateLoading("Löschen...")
    const result: HttpFunctionResult<any> = await this.saveSrv.deleteTaskTemplate(this.template.id)
    await this.feedback.hideLoading()
    if(!result.success) return

    this.templates.splice(this.templates.findIndex(t => t.id == this.template.id), 1)
    await this.back()

  }

  public async save(){
    if(this.templates.find(t => t.description == this.template.description) && this.isNew)
      return await this.feedback.showError("Die angegeben Bezeichnung existiert bereits. Bitte verwenden Sie eine Andere.")


    await this.feedback.updateLoading("Speichern...")
    if(this.isNew){
      const createResponse: HttpFunctionResult<TaskTemplateBase> = await this.saveSrv.createTaskTemplate(this.template)
      if(!createResponse.success) return await this.feedback.hideLoading()
      this.tasks.forEach(t => t.templateId = createResponse.data.id)
      const tasksResult: HttpFunctionResult<any> = await this.saveSrv.createOrUpdateTaskTemplateItems(this.tasks, createResponse.data.id)
      await this.feedback.hideLoading()
      if(!tasksResult.success) return
      this.templates.push(createResponse.data)
    }else{
      const updateResponse: HttpFunctionResult<TaskTemplateBase> = await this.saveSrv.updateTaskTemplate(this.template)
      if(!updateResponse.success) return await this.feedback.hideLoading()
      const tasksResult: HttpFunctionResult<any> = await this.saveSrv.createOrUpdateTaskTemplateItems(this.tasks, this.template.id)
      await this.feedback.hideLoading()
      if(!tasksResult.success) return
      this.templates.find(t => t.id == updateResponse.data.id).description = updateResponse.data.description
    }
 
    await this.back()

  }

}
